<template>
    <v-container class="paddingLeft" fluid style="padding-top: 80px;padding-left: 130px">
        <v-flex xs-12  class="text-center pt-5">
            <p class="display-2 font-weight-light">Tu compra esta pendiente de aprobación</p>
            <i class="material-icons light-blue--text accent-3" style="font-size: 7rem">
                access_time
            </i>
            <p class="mt-2">Te notificaremos via email al obtener respuesta de tu transacción,<br> para más información contactenos a soporte@cambiandotusalud.com</p>
            <router-link tag="a" to="/home/my_Courses"  class="btn btn-primary btn-lg pb-3 pt-3" style="border-radius: 40px; margin-top: 80px; color: white; width: 200px;  width: 250px; font-size: 1.5rem">Ir a mís Cursos</router-link>
        </v-flex>
        <v-divider style=”background-color:rgba(99,20,85,0)”></v-divider>
        <v-flex xs-12  class="text-left pt-1">
            <p class="font-weight-medium title pb-3">Tambien te puede interesar</p>
            <other-proyects></other-proyects>
        </v-flex>
    </v-container>
</template>
<script>
    import {mapState} from 'vuex'
    import axios from 'axios'
    import OtherProyects from './../../layouts/other_proyects.vue'
    export default {
        name: 'payment_pending',
        components: {
            OtherProyects,
        },
        created(){

        },
        data(){
            return {

            }
        },
        computed: {
            ...mapState,


        },
        methods:{

        }

    }
</script>
<style>
    @media screen and (max-width: 768px) {
        .paddingLeft{
            padding-left: 30px!important;
        }

    }
</style>